import { Suspense } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import BottomNav from './BottomNav'

const IMMERSIVE_ROUTES = ['/login']

// 局部 fallback：只在 main 区域显示，保留 AppShell 外壳与底部导航，
// 避免 lazy 页面首次加载时整个页面被顶层 Suspense 替换成全屏黑幕。
function PageFallback() {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      className="bg-bg"
    >
      <div
        style={{ width: 28, height: 28, borderWidth: 3, borderRadius: '50%' }}
        className="border-primary/30 border-t-primary animate-spin"
      />
    </div>
  )
}

export default function AppShell() {
  const location = useLocation()
  const hideNav = IMMERSIVE_ROUTES.some((r) => location.pathname.startsWith(r))

  // AgentPage (/) manages its own scroll internally; other pages need a scrollable wrapper
  const isAgent = location.pathname === '/' || location.pathname === '/agent'

  // 底部导航栏是 fixed 定位，需要给 main 留出等高的 margin
  // 使用 CSS calc 包含 safe-area-inset-bottom 以适配全面屏
  const bottomMargin = hideNav ? '0px' : 'calc(56px + env(safe-area-inset-bottom, 0px))'

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100dvh' }} className="bg-bg">
      {isAgent ? (
        /* Agent page: fixed layout, internal scroll */
        <main style={{ flex: 1, overflow: 'hidden', marginBottom: bottomMargin }}>
          <Suspense fallback={<PageFallback />}>
            <Outlet />
          </Suspense>
        </main>
      ) : (
        /* Other pages: scrollable */
        <main style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', marginBottom: bottomMargin }}>
          <Suspense fallback={<PageFallback />}>
            <Outlet />
          </Suspense>
        </main>
      )}
      {!hideNav && <BottomNav />}
    </div>
  )
}
